<template>
  <v-app>
    <v-system-bar
      v-if="$router.history.current.path !== '/login' && $vuetify.breakpoint.smAndDown && $store.getters.inPrivateNet"
      color="primary darken-3"
      app
    >
      <v-spacer></v-spacer>
      <v-icon class="white--text ma-0">mdi-connection</v-icon>
      <div
        class="ml-1 mr-2"
        style="color: white"
      >
        {{$store.state.general.current_user_list.length}}
      </div>
      <v-icon
        :class="get_signal_icon_props.color + ''"
      >
        {{ get_signal_icon_props.icon }}
      </v-icon>
      <v-chip
        class="white"
        x-small

      > {{ gssi_name }}
      </v-chip>
      <div
        class="ml-2 mr-1 white--text"
      >
        {{ time_string }}
      </div>
    </v-system-bar>


    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="favicon.ico"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ $store.state.user.displayName ? $store.state.user.displayName : $store.state.user.cn }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item
          v-for="(tab, index) in tabs"
          :key="index"
          link
          :to="tab.to"
          :disabled="tab.disabled"
        >
          <v-list-item-icon>
            <v-icon>{{ tab.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ tab.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>


    <v-app-bar
      v-if="$router.history.current.path !== '/login'"
      class="primary"
      dense
      app
      dark
      elevate-on-scroll
    >
      <!--- isMobile --->
      <v-app-bar-nav-icon v-if="isMobile && !isPublicService" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <img
        v-if="isMobile || isPublicService"
        src="@/assets/Garbsen_EZ_Feuerwehr_1farb_Weiß_RGB_Zeichenfläche 1.png"
        alt="Logo"
        style="max-height: 36px"
        contain
        class="mr-2"
      >
      <!--
      <v-toolbar-title
        v-if="isMobile || isPublicService"
      >
        ELOCOM
      </v-toolbar-title> -->
      <!--- isDesktop --->
      <v-tabs
        v-if="!(isMobile ||isPublicService)"
      >
        <v-tab
          v-for="(tab, index) in tabs"
          :key="index"
          :to="tab.to"
          :disabled="tab.disabled"
        >
          <v-icon
            class="mr-1"
          >
            {{tab.icon}}
          </v-icon>
          <v-badge
            v-if="tab.title === 'Ticketss'"
            color="success"
            dot
          >
            {{ tab.title }}
          </v-badge>
          <v-badge
            v-else-if="tab.title === 'Sirenen' && hasSirenenError"
            color="error"
            dot
          >
            {{ tab.title }}
          </v-badge>
          <div
            v-else
          >
            {{ tab.title }}
          </div>
        </v-tab>
      </v-tabs>
      <v-spacer></v-spacer>
      <!--- right side --->
      <v-chip
        v-if="$store.state.general.global_search.length > 0"
        class="ml-2 warning"
        style="white-space: nowrap; overflow: visible; max-width: none;"
      >
        Suchfilter aktiv
      </v-chip>
      <v-tooltip
        v-if="$store.getters.inPrivateNet && !isMobile"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            class="ml-2 d-flex align-center"
            v-bind="attrs"
            v-on="on"
            style="color: white"
          >
            <v-icon class="white--text ma-0 mr-1">mdi-connection</v-icon>
            {{$store.state.general.current_user_list.length}}
          </div>
        </template>
        <!-- Anzahl der offenen Verbindungen zu diesem Server. -->
        Offene Verbindungen zu diesem Server:
        <div
          v-for="(connection, index) in $store.state.general.current_user_list"
          :key="index"
        >
          {{connection.description}} - {{connection.ip}}
        </div>
      </v-tooltip>
      <v-tooltip
        v-if="$store.getters.inPrivateNet && !isMobile"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            class="ml-2 d-flex align-center"
            v-bind="attrs"
            v-on="on"
            style="color: white"
          >
            <v-icon
              :class="get_signal_icon_props.color + ''"
            >
              {{ get_signal_icon_props.icon }}
            </v-icon>
            <v-chip
              class="white ml-1 black--text"
              small
            >
              {{ gssi_name }}
            </v-chip>
          </div>
        </template>
        <div
        >
          {{ $store.state.device.display_name }} <br>
          OPTA: {{ $store.state.device.opta }} <br>
          ISSI: {{ $store.state.device.issi }} <br>
          GSSI: {{ gssi_name }} <br>
          RSSI: {{ $store.state.device.rssi }} <br>
        </div>
      </v-tooltip>
      <!--- END --->
      <div
        v-if="!(isMobile && $store.getters.inPrivateNet)"
        class="ml-2 white--text"
      >
        {{ time_string }}
      </div>
      <v-btn
        v-if="!isPublicService"
        class="ml-1"
        icon
        color="white"
        @click="$store.commit('logout')"
      >
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-main
      class="secondary"
    >
      <v-fab-transition
        duration="200"
      >
        <router-view />
      </v-fab-transition>
      <gnrl_magnify
        v-if="$router.history.current.path !== '/login' && $router.history.current.path !== '/faq' && !isPublicService"
      ></gnrl_magnify>
    </v-main>
    <gnrl_dialog></gnrl_dialog>
  </v-app>
</template>

<script>
import gnrl_dialog from "./components/general/gnrl_dialog";
import gnrl_magnify from "./components/general/gnrl_magnify";
import { hasAccess } from "@/plugins/permissions";
export default {
  components: { gnrl_magnify, gnrl_dialog },
  data: () => ({
    drawer: false, // tes
    group: null, // testt
    time_string: '',
    push_notifications: [],
    websocket: null,
    websocket_interval: null,
    base_tabs: [
      { title: "Tableau", to: "/", icon: "mdi-clipboard-list-outline", disabled: true },
      { title: "Tickets", to: "/tickets", icon: "mdi-ticket-confirmation-outline", disabled: true },
      { title: "VNC", to: "/vncs", icon: "mdi-monitor", disabled: true },
      { title: "Telefon", to: "/phonebook", icon: "mdi-phone-log", disabled: true },
      { title: "Broadcast", to: "/smsbroadcast", icon: "mdi-message-alert", disabled: true },
      { title: "Schließanlage", to: "/kentix", icon: "mdi-key-chain-variant", disabled: true },
      { title: "Notalarm", to: "/notalarm", icon: "mdi-alarm-bell", disabled: true },
      { title: "Sirenen", to: "/sirenen", icon: "mdi-bell-ring", disabled: true },
      { title: "Shop", to: "/shop", icon: "mdi-store-outline", disabled: true },
      //{ title: "Termine", to: "/termine", icon: "mdi-clipboard-text-clock-outline", disabled: true },
      { title: "FAQ", to: "/faq", icon: "mdi-frequently-asked-questions" },
    ],
  }),
  beforeCreate() {
    document.title = 'Stadtfeuerwehr Garbsen - ELOCOM'
    let authToken = localStorage.getItem("authToken")
    if(authToken === null){
      if(this.$router.history.current.path !== '/login' && !this.$router.history.current.path.startsWith("/public")){
        this.$router.push("/login")
      }
    }
    else {
      this.$store.commit('login', authToken)
    }
  },
  created() {
    if(this.$router.history.current.path !== '/login' && !this.isPublicService){
      this.$store.dispatch("update", { "context": "/device" })
      this.$store.dispatch("update", { "context": "/engines" })
      this.connect()
    }
  },
  mounted() {
    this.setTime()
    setInterval(this.setTime, 1000)
  },
  watch: {
    group () {
      this.drawer = false
    },
    '$route' (to) {
      document.title = to.meta.title || 'SFW Garbsen'
    },
    store_authToken(val, oldVal){
      // logout
      if(val === null && oldVal !== null){
        if(this.$router.history.current.path !== '/login') {
          localStorage.removeItem('authToken')
          this.$router.push("/login")
        }
      }
      // login
      if(val !== null && oldVal === null){
        this.$store.dispatch("update", { "context": "/device"  })
        this.$store.dispatch("update", { "context": "/engines" })
        this.connect()
      }
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    isPublicService() {
      return this.$router.history.current.path.startsWith('/public')
    },
    tabs() {
      return this.base_tabs.map(tab => {
        const route = this.$router.options.routes.find(r =>
          r.path.split('/:')[0] === tab.to
        );
        if (route) {
          const accessible = hasAccess(this.$store.state.user, route.meta || {}, this.$store.getters.inPrivateNet);
          return { ...tab, disabled: !accessible };
        }
        return { ...tab, disabled: true };
      }).filter(tab => !tab.disabled);
    },
    store_authToken() {
      return this.$store.state.user.authToken
    },
    gssi_name() {
      // Leerer Wert heisst "Rufgruppe unbekannt" - ein leerer Chip sagt dem Nutzer nichts.
      return this.$store.state.device.selected_GSSI_name || '-?-'
    },
    get_signal_icon_props() {
      let rssi = this.$store.state.device.rssi
      switch (true) {
        case (rssi == 0 || rssi == 99):
          return { "icon": "mdi-signal-off", "color": "red--text" }
        case (rssi <= 7):
          return { "icon": "mdi-signal-cellular-outline", "color": "red--text" }
        case (rssi <= 10):
          return { "icon": "mdi-signal-cellular-1", "color": "orange--text" }
        case (rssi <= 13):
          return { "icon": "mdi-signal-cellular-2", "color": "yellow--text" }
      }
      return { "icon": "mdi-signal-cellular-3", "color": "light-green--text" }
    },
    hasSirenenError(){
      return Object.values(this.$store.state.sirenen.sirenen).some(item => !item.isNotificationsOn);
    }
  },
  methods: {
    setTime() {
      let date = new Date();
      let hh = date.getHours();
      let mm = date.getMinutes();
      let ss = date.getSeconds();

      hh = (hh < 10) ? "0" + hh : hh;
      mm = (mm < 10) ? "0" + mm : mm;
      ss = (ss < 10) ? "0" + ss : ss;

      this.time_string = hh + ":" + mm + ":" + ss;
    },
    onMessage(ev) {
      const payload = JSON.parse(ev.data)
      this.$store.commit('process_input', payload)
    },
    onClose() {
      console.log("onclose")
      this.$store.dispatch("update", { "context": "/users/me" })
      clearInterval(this.websocket_interval)
      let thiis = this
      setTimeout(function(){
        if(thiis.$router.history.current.path !== '/login') {
          thiis.connect()
        }
      }, 10000);
    },
    onError() {
      console.log("onerror")
    },
    onOpen(){
      this.websocket.send(this.$store.state.user.authToken)
      let thiis = this
      this.websocket_interval = setInterval(
        function(){
          thiis.websocket.send(thiis.$store.state.user.authToken)
        } , 20000); // 20000
    },
    connect() {
      if(!this.isPublicService){
        let authToken = this.$store.state.user.authToken
        this.websocket = new WebSocket((this.$store.state.general.api_host + '/ws').replace('https', 'wss').replace('http', 'ws') + "?jwt=" + authToken)
        this.websocket.onmessage = this.onMessage
        this.websocket.onclose = this.onClose
        this.websocket.onerror = this.onError
        this.websocket.onopen = this.onOpen
      }
    }
  }
}
</script>
